module.exports = __webpack_public_path__ + "static/media/rectangle-pink.b392d417.svg";